import * as languages from "../lang/index";
export function getTranslation(word) {
  let lang = "tr-TR";
  // let lang = localStorage.getItem('lang') || "tr-TR";//navigator.language;
  lang = lang.split("-")[0];
  return languages.default[lang][word];
}
